import {
    getAuthenticated,
    putAuthenticated
} from '../../../../services/RestTemplate';

const clientCredentialsApi = '/client-credentials';

export const getClientCredentials = () =>
    getAuthenticated(clientCredentialsApi);

/* Makes the brands given the brands of the credential, in place of the ones it had. An empty list leaves it able to send for none. */
export const setClientBrands = (id, brandIds) =>
    putAuthenticated(`${clientCredentialsApi}/${id}/brands`, { brandIds });
